import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadBoardTruckSearchUsers extends Layout {
    sourcePnnTranscoreUser: DataSource;
    sourceUsers: DataSource;
    tablePnnTranscoreUsers: Table;
}
